// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root__LbklG","hasTitle":"Alert_hasTitle__PxSF5"};